import { ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';

import { Environment } from '@app/static/constants';

const META_DEFAULT = {
  DESCRIPTION:
    '理想の住まい探しをサポートする不動産・住宅情報サイト。住宅展示場や分譲物件の情報を提供し、見学予約や資料請求が簡単にできます。注文住宅を検討中の方に、家づくりに役立つ情報と信頼できる住宅会社との出会いをお届けします。',
  KEYWORDS: '住宅展示場,分譲地,見学,ホムホム,プロクラ',
  TITLE: 'ホムホム',
};

const isProEnvironment =
  process.env.REACT_APP_NODE_ENV === Environment.PRODUCTION;

type Props = {
  description?: string;
  isNoIndex?: boolean;
  keywords?: string;
  title?: string;
};

export function HeadBlock(props: Props): ReactElement {
  const { description, keywords, title } = props;

  const isNoIndex = !isProEnvironment || props.isNoIndex;

  // Canonical URLにクエリパラメーターを含めない
  const { protocol, host, pathname } = window.location;
  const canonicalUrl = `${protocol}//${host}${pathname}`;

  return (
    <Helmet>
      <title>{title ?? META_DEFAULT.TITLE}</title>
      <meta
        name="description"
        content={description ?? META_DEFAULT.DESCRIPTION}
      />
      <meta name="keywords" content={keywords ?? META_DEFAULT.KEYWORDS} />
      {isNoIndex && <meta name="robots" content="noindex" />}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

export function getProductsTitle(category?: string, value?: string): string {
  const prefix = value ? `${value}の` : '';
  return category
    ? `${prefix}の${category}住宅展示場、分譲地の一覧｜ホムホム`
    : META_DEFAULT.TITLE;
}

export function getProductsDescription(
  category?: string,
  value?: string
): string {
  const prefix = value ? `${value}の` : '';
  return category
    ? `【ホムホム】${prefix}、${category}理想の住まい探しをサポートする不動産・住宅情報サイト。住宅展示場や分譲物件の情報を提供し、見学予約や資料請求が簡単にできます。注文住宅を検討中の方に、家づくりに役立つ情報と信頼できる住宅会社との出会いをお届けします。`
    : META_DEFAULT.DESCRIPTION;
}

export function getProductsKeywords(category?: string, value?: string): string {
  const prefix = value ? `,${value}` : '';
  return category
    ? `${category}'住宅展示場,分譲地${prefix}`
    : META_DEFAULT.KEYWORDS;
}
